import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useAuthentication from '~/hooks/use-authentication';
import useOrganizations from '~/hooks/use-organizations';

// The url or localStorage seeds the assumed organization before /me resolves. Drop it once we know
// the user may not assume, or the organization does not exist.
function useAssumeOrganizationOnAppInit() {
  const { isGod, isDemiGod, userType, assumedOrganizationId, assumeOrganizationId } = useAuthentication();
  const { data: organizations, loading: isOrganizationsLoading, isOrgGod } = useOrganizations();
  const history = useHistory();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!assumedOrganizationId || !userType) return;

    const isGodly = isGod || isDemiGod;
    // OrgGods are only known once their elevated organizations have loaded
    if (!isGodly && isOrganizationsLoading) return;

    const canAssume = isGodly || isOrgGod;
    const exists = !organizations || organizations.some(({ id }) => id === assumedOrganizationId);
    if (!canAssume || !exists) assumeOrganizationId(null);
  }, [
    isGod,
    isDemiGod,
    isOrgGod,
    userType,
    assumedOrganizationId,
    assumeOrganizationId,
    organizations,
    isOrganizationsLoading,
  ]);

  // The first render already read the param, keeping it would lie after the next organization switch.
  useEffect(() => {
    const params = new URLSearchParams(search);
    if (!params.has('org_id')) return;

    params.delete('org_id');
    const query = params.toString();
    history.replace(query ? `${pathname}?${query}` : pathname);
  }, [pathname, search, history]);
}

export default useAssumeOrganizationOnAppInit;
